import React from 'react';
import Headline from '../layout/Headline';
import Loader from '../molecules/Loader';

const Loading = () => {
    return (
        <>
            <Headline />
			<Loader />
        </>
    );
}

export default Loading;
